import { useState, useEffect, useCallback, useMemo } from "react";
import apiInstance from "../Utils/api";
import { useSelector } from "react-redux";
import buildParams from "../Utils/buildParams";

export const useGetList = (endpoint, immediate = true) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const filter = useSelector((state) => state.filter);

  const params = useMemo(() => buildParams(filter), [filter]);

  const fetchData = useCallback(
    async (customParams = Object.keys(params).length ? params : undefined) => {
      setLoading(true);
      setError(null);

      try {
        const response = await apiInstance.get(endpoint, {
          params: customParams,
        });

        // setData(response.data.list || response.data.data || response.data);
        setData(response.data);

        // Update pagination if available

        return response.data;
      } catch (err) {
        const errorMessage =
          err.response?.data?.message ||
          err.message ||
          "An error occurred while fetching data";
        setError(errorMessage);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [endpoint, params],
  );

  const refetch = useCallback(() => {
    return fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (immediate) {
      fetchData();
    }
  }, [immediate, fetchData]);

  return {
    data,
    loading,
    error,
    refetch,
    fetchData,
  };
};
